import React, { useState } from 'react';
import Confirm from './Confirm';
import Toast from './Toast';

export default function Settings() {
  const [activeSection, setActiveSection] = useState('general');
  const [toast, setToast] = useState(null);
  const [confirmModal, setConfirmModal] = useState(null);
  const [displayName, setDisplayName] = useState('K Capital');
  const [darkMode, setDarkMode] = useState(true);
  const [ssoRequired, setSsoRequired] = useState(false);
  const [twoFaEnabled, setTwoFaEnabled] = useState(true);

  const sections = [
    { id: 'general', label: 'General', group: 'Workspace' },
    { id: 'brand', label: 'Brand', group: 'Workspace' },
    { id: 'authentication', label: 'Authentication', group: 'Security' },
    { id: 'sso', label: 'SSO & Integrations', group: 'Security' },
    { id: 'webhooks', label: 'Webhooks', group: 'Integrations' },
    { id: 'danger', label: 'Danger zone', group: 'Workspace' }
  ];

  const showToast = (msg) => {
    setToast({ message: msg, type: 'default' });
    setTimeout(() => setToast(null), 3000);
  };

  const handleSave = () => {
    showToast('Settings saved');
  };

  return (
    <div className="admin-page">
      <div className="admin-page__head">
        <div>
          <h1 className="admin-page__title">Settings</h1>
          <div className="admin-page__sub">
            <span>Workspace configuration</span>
          </div>
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '240px 1fr', gap: '32px' }}>
        <nav style={{ display: 'flex', flexDirection: 'column' }}>
          {['Workspace', 'Security', 'Integrations'].map((group) => (
            <div key={group} style={{ marginBottom: '24px' }}>
              <div style={{ fontSize: '10px', textTransform: 'uppercase', letterSpacing: '0.08em', color: 'var(--graphite)', marginBottom: '12px', paddingLeft: '12px' }}>
                {group}
              </div>
              {sections
                .filter(s => s.group === group)
                .map(section => (
                  <button
                    key={section.id}
                    onClick={() => setActiveSection(section.id)}
                    style={{
                      width: '100%',
                      padding: '10px 12px',
                      textAlign: 'left',
                      fontSize: '13px',
                      color: activeSection === section.id ? 'var(--ivory)' : 'var(--graphite-2)',
                      background: activeSection === section.id ? 'rgba(244,241,234,0.05)' : 'none',
                      border: 'none',
                      borderLeft: activeSection === section.id ? '2px solid var(--accent)' : '2px solid transparent',
                      cursor: 'pointer',
                      transition: 'all 0.15s'
                    }}
                  >
                    {section.label}
                  </button>
                ))}
            </div>
          ))}
        </nav>

        <div>
          {activeSection === 'general' && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '32px' }}>
              <div>
                <h3 style={{ fontSize: '14px', fontWeight: 600, color: 'var(--ivory)', marginBottom: '12px' }}>Display name</h3>
                <input
                  type="text"
                  value={displayName}
                  onChange={(e) => setDisplayName(e.target.value)}
                  style={{
                    width: '100%',
                    maxWidth: '400px',
                    padding: '10px 12px',
                    fontSize: '13px',
                    color: 'var(--ivory)',
                    background: 'rgba(244,241,234,0.02)',
                    border: '1px solid rgba(244,241,234,0.08)',
                    borderRadius: '4px',
                    fontFamily: 'inherit'
                  }}
                />
              </div>
              <div>
                <h3 style={{ fontSize: '14px', fontWeight: 600, color: 'var(--ivory)', marginBottom: '12px' }}>Domain</h3>
                <input
                  type="text"
                  value="kcapital.com"
                  readOnly
                  style={{
                    width: '100%',
                    maxWidth: '400px',
                    padding: '10px 12px',
                    fontSize: '13px',
                    color: 'var(--graphite-2)',
                    background: 'rgba(244,241,234,0.02)',
                    border: '1px solid rgba(244,241,234,0.08)',
                    borderRadius: '4px',
                    fontFamily: 'inherit'
                  }}
                />
              </div>
              <div>
                <h3 style={{ fontSize: '14px', fontWeight: 600, color: 'var(--ivory)', marginBottom: '12px' }}>Timezone</h3>
                <select style={{
                  width: '100%',
                  maxWidth: '400px',
                  padding: '10px 12px',
                  fontSize: '13px',
                  color: 'var(--ivory)',
                  background: 'rgba(244,241,234,0.02)',
                  border: '1px solid rgba(244,241,234,0.08)',
                  borderRadius: '4px',
                  fontFamily: 'inherit'
                }}>
                  <option>UTC</option>
                  <option selected>Europe/London</option>
                  <option>Europe/Berlin</option>
                </select>
              </div>
              <button
                onClick={handleSave}
                style={{
                  width: 'fit-content',
                  padding: '10px 20px',
                  background: 'var(--accent)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  fontSize: '13px',
                  fontWeight: 500,
                  cursor: 'pointer'
                }}
              >
                Save changes
              </button>
            </div>
          )}

          {activeSection === 'brand' && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '32px' }}>
              <div>
                <h3 style={{ fontSize: '14px', fontWeight: 600, color: 'var(--ivory)', marginBottom: '12px' }}>Accent colour</h3>
                <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                  <input
                    type="color"
                    defaultValue="#8b2a1f"
                    style={{
                      width: '60px',
                      height: '60px',
                      border: '1px solid rgba(244,241,234,0.08)',
                      borderRadius: '4px',
                      cursor: 'pointer'
                    }}
                  />
                  <span style={{ fontSize: '13px', color: 'var(--graphite-2)' }}>#8b2a1f</span>
                </div>
              </div>
              <div>
                <h3 style={{ fontSize: '14px', fontWeight: 600, color: 'var(--ivory)', marginBottom: '12px' }}>Dark mode</h3>
                <button
                  onClick={() => setDarkMode(!darkMode)}
                  style={{
                    padding: '6px 12px',
                    background: darkMode ? 'var(--accent)' : 'rgba(244,241,234,0.05)',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    fontSize: '12px',
                    fontWeight: 500,
                    cursor: 'pointer'
                  }}
                >
                  {darkMode ? '◉ Enabled' : '◯ Disabled'}
                </button>
              </div>
              <button
                onClick={handleSave}
                style={{
                  width: 'fit-content',
                  padding: '10px 20px',
                  background: 'var(--accent)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  fontSize: '13px',
                  fontWeight: 500,
                  cursor: 'pointer'
                }}
              >
                Save changes
              </button>
            </div>
          )}

          {activeSection === 'authentication' && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
              <div style={{ padding: '12px', background: 'rgba(244,241,234,0.03)', borderRadius: '4px', border: '1px solid rgba(244,241,234,0.08)' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div>
                    <h4 style={{ fontSize: '13px', fontWeight: 600, color: 'var(--ivory)', marginBottom: '2px' }}>SSO required</h4>
                    <div style={{ fontSize: '12px', color: 'var(--graphite-2)' }}>Require all users to sign in via SSO</div>
                  </div>
                  <button
                    onClick={() => setSsoRequired(!ssoRequired)}
                    style={{
                      padding: '6px 12px',
                      background: ssoRequired ? 'var(--accent)' : 'rgba(244,241,234,0.05)',
                      color: 'white',
                      border: 'none',
                      borderRadius: '4px',
                      fontSize: '11px',
                      fontWeight: 500,
                      cursor: 'pointer'
                    }}
                  >
                    {ssoRequired ? '◉' : '◯'}
                  </button>
                </div>
              </div>

              <div style={{ padding: '12px', background: 'rgba(244,241,234,0.03)', borderRadius: '4px', border: '1px solid rgba(244,241,234,0.08)' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div>
                    <h4 style={{ fontSize: '13px', fontWeight: 600, color: 'var(--ivory)', marginBottom: '2px' }}>Two-factor authentication</h4>
                    <div style={{ fontSize: '12px', color: 'var(--graphite-2)' }}>Require 2FA for all users</div>
                  </div>
                  <button
                    onClick={() => setTwoFaEnabled(!twoFaEnabled)}
                    style={{
                      padding: '6px 12px',
                      background: twoFaEnabled ? 'var(--accent)' : 'rgba(244,241,234,0.05)',
                      color: 'white',
                      border: 'none',
                      borderRadius: '4px',
                      fontSize: '11px',
                      fontWeight: 500,
                      cursor: 'pointer'
                    }}
                  >
                    {twoFaEnabled ? '◉' : '◯'}
                  </button>
                </div>
              </div>

              <button
                onClick={handleSave}
                style={{
                  width: 'fit-content',
                  padding: '10px 20px',
                  background: 'var(--accent)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  fontSize: '13px',
                  fontWeight: 500,
                  cursor: 'pointer'
                }}
              >
                Save changes
              </button>
            </div>
          )}

          {activeSection === 'sso' && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
              {['Microsoft Entra ID', 'Google Workspace', 'Okta'].map((provider) => (
                <div key={provider} style={{ padding: '12px', background: 'rgba(244,241,234,0.03)', borderRadius: '4px', border: '1px solid rgba(244,241,234,0.08)' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h4 style={{ fontSize: '13px', fontWeight: 600, color: 'var(--ivory)' }}>{provider}</h4>
                    <button style={{
                      padding: '6px 12px',
                      background: 'transparent',
                      color: 'var(--graphite-2)',
                      border: '1px solid rgba(244,241,234,0.08)',
                      borderRadius: '4px',
                      fontSize: '12px',
                      cursor: 'pointer'
                    }}>
                      Configure
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}

          {activeSection === 'webhooks' && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                  <thead>
                    <tr style={{ borderBottom: '1px solid rgba(244,241,234,0.08)' }}>
                      <th style={{ textAlign: 'left', padding: '12px 0', color: 'var(--graphite-2)', fontWeight: 500 }}>Endpoint</th>
                      <th style={{ textAlign: 'left', padding: '12px 0', color: 'var(--graphite-2)', fontWeight: 500 }}>Events</th>
                      <th style={{ textAlign: 'left', padding: '12px 0', color: 'var(--graphite-2)', fontWeight: 500 }}>Status</th>
                      <th style={{ textAlign: 'left', padding: '12px 0', color: 'var(--graphite-2)', fontWeight: 500 }}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {[
                      { endpoint: 'https://api.slack.com/events', events: 'publish, review', status: 'active' },
                      { endpoint: 'https://integrations.example.com/hook', events: 'publish', status: 'active' }
                    ].map((hook, idx) => (
                      <tr key={idx} style={{ borderBottom: '1px solid rgba(244,241,234,0.04)' }}>
                        <td style={{ padding: '12px 0', color: 'var(--ivory)' }}>{hook.endpoint}</td>
                        <td style={{ padding: '12px 0', color: 'var(--graphite-2)', fontSize: '12px' }}>{hook.events}</td>
                        <td style={{ padding: '12px 0' }}>
                          <span style={{ fontSize: '10px', padding: '2px 6px', backgroundColor: 'rgba(139,42,31,0.2)', color: '#E8A5A5', borderRadius: '2px' }}>
                            {hook.status}
                          </span>
                        </td>
                        <td style={{ padding: '12px 0', textAlign: 'right' }}>
                          <button style={{ background: 'none', border: 'none', color: 'var(--graphite-2)', cursor: 'pointer', fontSize: '14px' }}>⋯</button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <button style={{
                width: 'fit-content',
                padding: '10px 20px',
                background: 'transparent',
                color: 'var(--graphite-2)',
                border: '1px solid rgba(244,241,234,0.08)',
                borderRadius: '4px',
                fontSize: '13px',
                cursor: 'pointer'
              }}>
                + Add webhook
              </button>
            </div>
          )}

          {activeSection === 'danger' && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '24px', borderTop: '1px solid rgba(244,241,234,0.08)', paddingTop: '24px' }}>
              {[
                { label: 'Reset admin password', description: 'Send a password reset email to all admins' },
                { label: 'Clear all cache', description: 'Regenerate all cached assets and data' },
                { label: 'Delete workspace', description: 'Permanently delete this workspace and all data' }
              ].map((action, idx) => (
                <div key={idx} style={{ padding: '12px', background: 'rgba(232,93,93,0.1)', borderRadius: '4px', border: '1px solid rgba(232,93,93,0.2)' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div>
                      <h4 style={{ fontSize: '13px', fontWeight: 600, color: '#E85D5D', marginBottom: '2px' }}>{action.label}</h4>
                      <div style={{ fontSize: '12px', color: 'var(--graphite-2)' }}>{action.description}</div>
                    </div>
                    <button
                      onClick={() => setConfirmModal(idx)}
                      style={{
                        padding: '8px 16px',
                        background: '#E85D5D',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        fontSize: '12px',
                        fontWeight: 500,
                        cursor: 'pointer'
                      }}
                    >
                      {idx === 2 ? 'Delete' : 'Execute'}
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {confirmModal !== null && (
        <Confirm
          title={confirmModal === 2 ? 'Delete workspace?' : 'Execute action?'}
          description={confirmModal === 2 ? 'This will permanently delete this workspace and all associated data. This cannot be undone.' : 'Are you sure? This action cannot be undone.'}
          danger={confirmModal === 2}
          onConfirm={() => {
            showToast('Action completed');
            setConfirmModal(null);
          }}
          onCancel={() => setConfirmModal(null)}
        />
      )}

      {toast && <Toast message={toast.message} type={toast.type} />}
    </div>
  );
}
